import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import type { ColumnDef } from "../../components/base-table-layout";
import { createEhrWriteBackColumn } from "../../ehr/create-ehr-column";
import { useEhrContext } from "../../../shared-logic/ehr-context/ehr-context";
import { BaseTableLayout } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { LabRowData } from "./lab-rows";

export type LabTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
  isRowViewed?: (row: TableRow) => boolean;
};

export function LabTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Labs",
  isRowViewed,
}: LabTableProps) {
  const ehrContext = useEhrContext();

  const columns = useMemo(() => {
    const cols: ColumnDef<LabRowData>[] = [
      { key: "observation", header: "Observation", maxWidth: "300px" },
      { key: "value", header: "Value" },
      { key: "interpretation", header: "Interpretation" },
      { key: "referenceRange", header: "Reference Range" },
      { key: "date", header: "Date", maxWidth: "150px", sort: "desc" },
    ];

    const ehrColumn = createEhrWriteBackColumn<LabRowData>(ehrContext, "lab");
    if (ehrColumn) cols.push(ehrColumn);

    return cols;
  }, [ehrContext]);

  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as LabRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
      getRowStyle={row => ({
        ...(row.backgroundColor ? { bg: row.backgroundColor } : {}),
        ...(row.hoverColor ? { _hover: { bg: row.hoverColor } } : {}),
      })}
    />
  );
}
